//import axios from 'axios'
import { apiObject, moveableObject } from './apiobject'
import { getPaginatedResults } from '@/store/index.js'

const referencetypes = {
    ...apiObject,
    ...moveableObject,
    url: '/referencetypes/',
    getProjectReferenceTypes (project_id) {
      return new Promise((resolve) => {
        getPaginatedResults(this.url, { 'project_id': project_id }, resolve);
      });
    },
}

export default {
    referencetypes
}
